import React from 'react';
import { Button } from "../../../components/ui/Button";
import { FileSpreadsheet } from "lucide-react";
import OnlyOfficeEditor from "../../../components/common/OnlyOfficeEditor";

export const XlViewer = ({ selectedDocument, onClose }) => {
  if (!selectedDocument) return null;

  // Retrieve user from local storage
  const user = JSON.parse(localStorage.getItem('blum_user') || '{}');

  return (
    <div className="flex-1 border border-slate-200 rounded-lg bg-white overflow-hidden shadow-sm flex flex-col min-h-[500px]">
      <div className="flex items-center justify-between p-4 border-b border-slate-200 bg-slate-50/80 shrink-0 z-10">
        <div className="flex items-center gap-3 min-w-0">
          <div className="w-8 h-8 rounded-lg bg-emerald-100 text-emerald-600 flex items-center justify-center shrink-0">
            <FileSpreadsheet size={18} />
          </div>
          <h3 className="text-sm font-medium text-slate-800 truncate">{selectedDocument.title}</h3>
        </div>
        <Button 
          variant="ghost" 
          size="sm" 
          onClick={onClose} 
          className="h-8 text-slate-500 hover:text-slate-800 hover:bg-slate-200 shrink-0 ml-2"
        >
          Close View
        </Button>
      </div>
      
      <div className="flex-1 relative bg-slate-50 flex flex-col overflow-hidden">
        <OnlyOfficeEditor 
          doc={selectedDocument} 
          user={user} 
          documentType="cell" 
        />
      </div>
    </div>
  );
};
